/* src/app/shared/components/transaction-modal/transaction-modal.component.scss */
.max-height {
  height: 100%;
}
.form-input-invalid {
  color: red;
  font-weight: 300;
  font-style: italic;
  font-size: small;
}
:host {
  height: 100%;
}
.form .list .bottom-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form .date-container {
  margin-top: 2vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-validate-custom {
  width: 200px;
  margin-top: 40px;
}
/*# sourceMappingURL=transaction-modal.component.css.map */
